//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";
export default {
  name: "SectionMunicipalityTopEntity",
  components: {
    Icon24FillExcursion: () => import('@/assets/icons/Icon24FillExcursion.svg?inline'),
    Icon24FillLocation: () => import('@/assets/icons/Icon24FillLocation.svg?inline'),
    Icon24FillDistance: () => import('@/assets/icons/Icon24FillDistance.svg?inline'),
    TopEntityComponent: () => import("@/components/common/TopEntityComponent"),
    Section: () => import("@/components/common/Section")
  },
  computed: {
    ...mapGetters({
      image: 'municipality/image',
      routesCount: 'municipality/routesCount',
      placesCount: 'municipality/placesCount',
      excursionsCount: 'municipality/excursionsCount',
    }),
    images() {
      return [this?.image || require('~/assets/images/default-image.svg')]
    }
  },
  methods: {
    toPlaces() {
      this.$router.push(this.$i18n.locale === this.$i18n.defaultLocale
        ? `/places?slug=${this.$route.params.slug}`
        : `/${this.$i18n.locale}/places?slug=${this.$route.params.slug}`)
    },
    toRoutes() {
      this.$router.push(this.$i18n.locale === this.$i18n.defaultLocale
        ? `/routes?slug=${this.$route.params.slug}`
        : `/${this.$i18n.locale}/routes?slug=${this.$route.params.slug}`)
    },
    toExcursions() {
      this.$router.push(this.$i18n.locale === this.$i18n.defaultLocale
        ? `/excursions?slug=${this.$route.params.slug}`
        : `/${this.$i18n.locale}/excursions?slug=${this.$route.params.slug}`)
    },
  }
};
